import React from "react";
import { useRouterContext, TitleProps } from "@pankod/refine-core";
import { Button } from "@pankod/refine-mui";

export const Title: React.FC<TitleProps> = ({ collapsed }) => {
  const { Link } = useRouterContext();

  return (
    <Button
      fullWidth
      variant="text"
      disableRipple
      sx={{ minWidth: 0, p: 0 }}
    >
      <Link to="/">
        <img
          src="/image/pps_academy_logo.png"
          alt="PPS Academy"
          width={collapsed ? 64 : 190}
          style={{
            display: "block",
            height: "auto",
            transform: collapsed ? "none" : "translateY(10px)",
          }}
        />
      </Link>
    </Button>
  );
};
